// src/utils/auth.js
import axios from "axios";
import Api from "@/utils/api";

export const ID_TOKEN_KEY = "token";

export function isLoggedIn() {
  const idToken = getIdToken();
  setAxiosHeader();
  return !!idToken;
}

export function getIdToken() {
  if (process.env.NODE_ENV === "test") {
    return process.env.TEST_TOKEN;
  } else {
    return localStorage.getItem("token");
  }
}

export function noAuth(to, from, next) {
  if (isLoggedIn()) {
    next({ path: "/" });
  } else {
    next();
  }
}

export function logout() {
  clearIdToken();
}

export function login(idToken) {
  localStorage.setItem("token", idToken);
  setAxiosHeader();
}

function clearIdToken() {
  localStorage.removeItem("token");
}

export function setAxiosHeader() {
  axios.defaults.headers.common["Authorization"] = "Bearer " + getIdToken();
  axios.defaults.headers.common["Access-Control-Allow-Headers"] =
  "x-requested-with";
axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
}

export function loginGoogle(idToken) {
  localStorage.setItem("token", idToken);
  setAxiosHeader();
}


export async function validateSession(to, from, next) {
  let token = await localStorage.getItem("tokenB64");
  let isRedirect = location.search.split("?")[1];
  if (token) {
    fetch(`${process.env.VUE_APP_PWA_BACK}/v1/local-auth/api/currentUser`, {
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
      },
    })
      .then(async (response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status} ${response.statusText}`);
        }
        await response.json(); // Procesar respuesta
  
        if (!isRedirect && to.path !== "/apps") {
          next({ path: "/apps" });
        } else {
          next();
        }
      })
      .catch((error) => {
        localStorage.clear();
        sessionStorage.clear();
        location.reload();
        // window.location.href = "https://login.okan.tools/login";
        saveLog(error.message, 357, 'Logout por expiración Okan');
      });
  }
}

export function saveLog(cc, appId, appName) {
  let dispositivo;
  if (screen.width < 1024) {
    dispositivo = "Mobile";
  } else {
    dispositivo = "Desktop";
  }
  const record = {
    userid: cc,
    appid: appId + "",
    appname: appName,
    // date: moment().format("YYYY-MM-DD"),
    dispositivo,
  };

  Api.Auth()
    .saveAppActivity(record)
    .then((resp) => resp.json())
    .catch((error) => {
      console.log(error);
    });
}
